import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

export default function CTA() {
  const ref = useRef(null);
  const v = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="cta" data-testid="cta-section" ref={ref} className="cta-section">
      <div className="cta-glow" aria-hidden="true" />

      <div className="container cta-inner">
        <motion.div initial={{ opacity: 0, y: 40 }} animate={v ? { opacity: 1, y: 0 } : {}} transition={{ duration: 1, ease: [0.25, 1, 0.5, 1] }}>
          <h2 data-testid="cta-title" className="cta-title">Get early access to Bonk</h2>
          <p className="cta-lead">
            Join the waitlist for launch updates on open-source DJ tooling with Rekordbox sync, advanced prep workflows, and faster metadata cleanup.
          </p>

          <div className="cta-actions">
            <motion.a
              className="btn btn-primary btn-lg cta-btn"
              href="#contact"
              data-testid="cta-download-btn"
              whileHover={{ scale: 1.02, boxShadow: '0 8px 24px rgba(0,0,0,0.5)' }}
              whileTap={{ scale: 0.98 }}
              onClick={(e) => { e.preventDefault(); document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' }); }}
            >
              Join Waitlist <ArrowRight size={16} aria-hidden="true" />
            </motion.a>
          </div>

          <p className="cta-platforms">Launching on macOS · Windows · Linux</p>
        </motion.div>
      </div>
    </section>
  );
}
